module.exports = "/_next/static/images/b0af5461354b77d555f24bdb188ab153-hick@1x.png";